module.exports = __webpack_public_path__ + "src/assets/img/product-laka-2.b766cfb0.png";